// The Nexus mark ("N>", after AllCode's "A>"): a rounded N in the ink colour and AllCode's red
// chevron. Inline so the N follows the app's theme (--logo-ink), which can differ from the OS
// setting the favicon's own media query follows.
export function LogoMark({ class: className = "brand-mark", title }: { class?: string; title?: string }) {
  return (
    <svg
      class={className}
      viewBox="0 0 64 64"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : "true"}
      focusable="false"
    >
      <path class="logo-n" d="M8 50V14l22 36V14" stroke-width="8.5" />
      <path class="logo-chevron" d="M41 20l12 12-12 12" stroke-width="8.5" />
    </svg>
  );
}

// The product lockup, "Nexus by AllCode": "Nexus" large and semibold, "by AllCode" smaller and
// lighter on the same baseline. The space between them is real text, so it reads (and copies) as
// one phrase. `size` picks the sidebar scale or the larger sign-in scale.
export function Lockup({ size = "sm" }: { size?: "sm" | "lg" }) {
  return (
    <span class={`lockup lockup-${size}`}>
      <span class="lockup-name">Nexus</span> <span class="lockup-by">by AllCode</span>
    </span>
  );
}
